var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinkedin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 21 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#linkedin_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3.919 3.843A2.25 2.25 0 1 0 .737.659a2.25 2.25 0 0 0 3.182 3.184M.079 6h4.5v13.5h-4.5zm7.5 0h4.15v2.127h.06C12.365 7.09 13.778 6 15.885 6c4.381 0 5.191 2.727 5.191 6.274V19.5H16.75v-6.404c0-1.527-.032-3.494-2.25-3.494-2.253 0-2.598 1.664-2.598 3.382V19.5H7.578z",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "linkedin_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h21v20H0z"
})))));
export default SvgLinkedin;